// removed by extract-text-webpack-plugin
module.exports = {"btn-apex-primary":"NmjWaEO8Qa1BVG9QHF5RU","focus":"_2WVON-732nFQsX-Y8HVo_r","active":"_34i1ejj8o33_SBqYlr1EN2","disabled":"_GijlcSsRihKu-h4w_2Gu","badge":"_3mledRVpHoAVIbwDFF8GMG","btn-apex-secondary":"EfwkRHWFib9K3cT_qvg4i","btn-apex-secondary-no-hover":"_2Ux6rbWfLagXpDWT5eTbkK","btn-apex-negative":"_2J-J_xHegPwsXAiH0wBTb0","btn-apex-orange":"o-_ONy_2C_LIkQfvixJPp","list":"_14RIzC-3Dj7HEOiJKORICF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DefListColumn/styles.css
// module id = 3134
// module chunks = 0